import {
  createSlice
} from '@reduxjs/toolkit';
import {
  getHomeDataAction,
  getWelcomeAction,
  getKPIsAction
} from 'redux/actions/home';

const initialState = {
  init: false,
  home: [],
  auth: [],
  loading: false,
};

// First import your thunk then add thunk lifecycle handlers
export const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    setInit(state, action) {
      state.init = action.payload;
    },
  },
  extraReducers: {
    [getHomeDataAction.pending]: (state) => {
      state.loading = true;
    },
    [getHomeDataAction.fulfilled]: (state, action) => {
      state.home = action.payload;
      state.loading = false;
    },
    [getHomeDataAction.rejected]: (state) => {
      state.loading = false;
    },
    [getKPIsAction.pending]: (state) => {
      state.loading = true;
    },
    [getKPIsAction.fulfilled]: (state, action) => {
      state.kpis = action.payload;
      state.loading = false;
    },
    [getKPIsAction.rejected]: (state) => {
      state.loading = false;
    },
    [getWelcomeAction.pending]: (state) => {
      state.loading = true;
    },
    [getWelcomeAction.fulfilled]: (state, action) => {
      state.auth = action.payload;
      state.loading = false;
    },
    [getWelcomeAction.rejected]: (state) => {
      state.loading = false;
    },
  },
});

// export auto-generated action creators from the reducer
export const {
  setInit
} = homeSlice.actions;
// export the reducer to be passed to configureStore
export default homeSlice.reducer;